<template>
  <note-component :node="node" :rows="6" />
</template>

<script>
import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object
  },
  components: {
    NoteComponent
  }
}
</script>
